// extracted by mini-css-extract-plugin
export default {"external":"aBd82H","wrapper":"bBd82H","link":"cBd82H","block":"dBd82H","grid":"eBd82H","title":"fBd82H"};